import React, { Component } from 'react';
const styles = require('./styles.scss');

interface IState {
    open: boolean
}

interface IProps {
    selectedLanguage: string;
    handleLanguageChange: any;
}

const languages = [
    {
        name: 'English',
        code: 'en'
    },
    {
        name: 'Français',
        code: 'fr'
    },
    {
        name: 'Deutsch',
        code: 'de'
    },
    {
        name: 'Italiano',
        code: 'it'
    }
]

export default class LanguageComponent extends Component<IProps, IState> {
    public wrapperRef;

    constructor(props) {
        super(props);

        this.state = {
            open: false
        }

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ open: false })
        }
    }

    render() {
        const btnClasses = ['btn btn-link btn-icon'];
        if (this.state.open) {
            btnClasses.push('active')
        }
        return (<div ref={this.wrapperRef} className={styles.language_selector}>
            {/* <ul id='language'>
                {
                    languages.map((lang, i) => (
                        <li value={lang.code}
                            onClick={(e) => this.props.handleLanguageChange(lang.code)}>{lang.name}</li>
                    ))
                }
            </ul> */}

            <div className={styles.language_dropdown + ' dropdownGloble'} >
                <button className={btnClasses.join(' ')}
                    onClick={() => this.setState({ open: !this.state.open })}>
                    <svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28' fill='none'>
                        <path
                            d='M14 22.3334C18.6024 22.3334 22.3334 18.6025 22.3334 14.0001C22.3334 9.39771 18.6024 5.66675 14 5.66675C9.39765 5.66675 5.66669 9.39771 5.66669 14.0001C5.66669 18.6025 9.39765 22.3334 14 22.3334Z'
                            stroke='#00005A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'></path>
                        <path d='M5.66669 14H22.3334' stroke='#00005A' strokeWidth='1.5' strokeLinecap='round'
                            strokeLinejoin='round'></path>
                        <path
                            d='M14 5.66675C16.0844 7.94871 17.269 10.9101 17.3334 14.0001C17.269 17.0901 16.0844 20.0515 14 22.3334C11.9156 20.0515 10.7311 17.0901 10.6667 14.0001C10.7311 10.9101 11.9156 7.94871 14 5.66675V5.66675Z'
                            stroke='#00005A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'></path>
                    </svg>
                    <span>{this.props.selectedLanguage.toLocaleUpperCase()}</span>
                </button>
                {
                    this.state.open && <div className={styles.menu}>
                        <div className={styles.language_dropdown_container} >
                            <ul className={styles.language_dropdown_menu}>
                                {
                                    languages.map((lang, i) => {
                                        return this.props.selectedLanguage === lang.code
                                            ? <li className={[styles.dropdown_item, styles.active].join(' ')} value={lang.code}
                                                onClick={(e) => { this.props.handleLanguageChange(lang.code); this.setState({ open: false }) }} key={i} >{lang.name}</li>
                                            : <li className={styles.dropdown_item} value={lang.code}
                                                onClick={(e) => { this.props.handleLanguageChange(lang.code); this.setState({ open: false }) }} key={i}>{lang.name}</li>
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                }
            </div>
        </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/language-selector/language.component.tsx